export type Counts = Record<string, number>;
export type WeeklyReportDraft = {
  contactCount: number;
  domains: Counts;
  topics: Record<string, Counts>;
  outcomes: Counts;
};
export const total = (counts: Counts) => Object.values(counts).reduce((sum, count) => sum + count, 0);
// Domains and topics can overlap; only counts above the per-option limit are excessive.
export const excessAssignments = (counts: Counts, max: number) =>
  Object.values(counts).reduce((sum, count) => sum + Math.max(0, count - max), 0);
export const setCount = (counts: Counts, key: string, count: number): Counts => {
  const next = { ...counts };
  if (Number.isSafeInteger(count) && count > 0) next[key] = count;
  else delete next[key];
  return next;
};
export const isValidReport = (draft: WeeklyReportDraft) => {
  const positive = (counts: Counts, max: number) =>
    Object.values(counts).every((count) => Number.isSafeInteger(count) && count > 0 && count <= max);
  return (
    Number.isSafeInteger(draft.contactCount) &&
    draft.contactCount > 0 &&
    positive(draft.domains, draft.contactCount) &&
    total(draft.domains) >= draft.contactCount &&
    Object.entries(draft.domains).every(
      ([domain, count]) => positive(draft.topics[domain] ?? {}, count) && total(draft.topics[domain] ?? {}) >= count,
    ) &&
    Object.keys(draft.topics).every((domain) => domain in draft.domains) &&
    positive(draft.outcomes, draft.contactCount) &&
    total(draft.outcomes) === draft.contactCount
  );
};
